import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { TokenServiceService } from './token-service.service';
import { map } from 'rxjs/operators';
import { environment as ENV } from 'environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class InterceptorRespService implements HttpInterceptor {
  token: string;
  state: string;
  route: string;
  taakol = ENV.shareKey;

  constructor(
    private tokenService: TokenServiceService,
    private tokenBifur: TokenServiceService
  ) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedRequest = req;

    // Check if the request URL includes "getUserVerified"
    try {
      // debugger
      if (req.url.includes("/login/login") && ENV.enableEncoding) {
        // if (ENV.enableEncoding) {
        // Encode payload to Base64 for outgoing requests
        if (req.body) {
          // const encodedBody = btoa(JSON.stringify(req.body));

          // // Clone the request with the encoded body
          // clonedRequest = req.clone({
          //   body: {data:encodedBody}
          // });

          // // Convert the JSON string to a Uint8Array
          // const buffer = new TextEncoder().encode(JSON.stringify(req.body));

          // // Convert the Uint8Array to a Base64 string
          // let stringFromBuffer = '';
          // for (let i = 0; i < buffer.length; i++) {
          //   stringFromBuffer += String.fromCharCode(buffer[i]);
          // }

          // const base64String = btoa(stringFromBuffer);

          // // Resulting Base64 string
          // console.log(base64String);
          let itsAstringNow = JSON.stringify(req.body);
          let garbledString = this.encrypt(itsAstringNow, this.taakol);
          clonedRequest = req.clone({
            body: { data: garbledString }
          });

        }

        return next.handle(clonedRequest).pipe(
          map(event => {
            // Decode the response if it's an HttpResponse
            if (event instanceof HttpResponse) {
              // // const decodedBody = atob(event.body.data);
              // // const parsedBody = JSON.parse(decodedBody);
              // // console.log(parsedBody)
              // // return event.clone({ body: parsedBody });

              // // Decode Base64 string to binary data (Uint8Array)
              // const base64String = event.body.data; // Your Base64 string
              // const binaryString = atob(base64String); // Decode Base64 to binary
              // let byteArray = new Uint8Array(binaryString.split('').map(char => char.charCodeAt(0)));
              // // Convert binary string to Uint8Array
              // // const binaryLength = binaryString.length;
              // // const buffer = new Uint8Array(binaryLength);
              // // for (let i = 0; i < binaryLength; i++) {
              // //     buffer[i] = binaryString.charCodeAt(i);
              // // }

              // // Use TextDecoder to decode the Uint8Array into a string
              // const textDecoder = new TextDecoder('utf-8'); // Specify encoding (default is UTF-8)
              // const decodedBody = textDecoder.decode(byteArray);

              // // Parse the JSON (since your backend sent encoded JSON)
              // const parsedBody = JSON.parse(decodedBody);

              // console.log(parsedBody);
              const garbledString = event.body.data;
              const oohItsSomethingNow = this.decrypt(garbledString, this.taakol);
              return event.clone({ body: oohItsSomethingNow });
            }

            return event; // Return the event unchanged if it's not an HttpResponse
          })
        );

      } else {
        return next.handle(req);
      }
    } catch (err) {
      console.log(err)
    }

  }

  encrypt(value: string, key): string {
    return CryptoJS.AES.encrypt(value, key.trim()).toString();
  }
  decrypt(textToDecrypt: string, key) {
    return JSON.parse(CryptoJS.AES.decrypt(textToDecrypt, key.trim()).toString(CryptoJS.enc.Utf8));
  }


}